import {
  stringifyParams
} from 'helpers/query_params';

angular.module('gym.gocardless').controller('GoCardlessAPILogsCtrl', ["$rootScope", "$scope", "$state", "$modal", "$timeout", "ngTableParams", "ToggleTableFiltersService", "GoCardless", "loadingAnimation", "flash", function($rootScope, $scope, $state, $modal, $timeout, ngTableParams, ToggleTableFiltersService, GoCardless, loadingAnimation, flash) {
  var gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.filters = {};
  $scope.filterStatuses = ['success', 'fail'];
  $scope.filterActions = ['customers_create', 'payments_create', 'creditors_list', 'mandates_list', 'payouts_get', 'redirect_flows_create', 'redirect_flows_complete', 'redirect_flows_get', 'mandates_get', 'customer_bank_accounts_get', 'mandates_cancel', 'payments_cancel'];
  $scope.pageParams = {
    filtersOpen: ToggleTableFiltersService.isOpen('GoCardlessAPILogs')
  };
  $scope.toggleFilters = function() {
    $scope.pageParams.filtersOpen = !$scope.pageParams.filtersOpen;
    return ToggleTableFiltersService.toggle($scope.pageParams.filtersOpen, 'GoCardlessAPILogs');
  };
  $scope.toggleFiltersModal = function() {
    var filtersModal;
    filtersModal = $modal.open({
      template: require('templates/gyms/gocardless/api_logs/filters_modal.html.slim'),
      resolve: {
        options: function() {
          return {
            filterStatuses: $scope.filterStatuses,
            filterActions: $scope.filterActions
          };
        },
        filters: function() {
          return $scope.filters;
        }
      },
      controller: 'FiltersModalCtrl'
    });
    return filtersModal.result.then(function(result) {
      $scope.filters = result;
      $scope.pageParams.invoice_number = $scope.filters.invoice_number;
      return $scope.reload();
    });
  };
  $scope.showParams = function(params) {
    return $modal.open({
      template: require('templates/gyms/gocardless/logs_params_modal.html.slim'),
      controller: 'LogsParamsModalCtrl',
      resolve: {
        params: function() {
          return params;
        },
        title: function() {
          return 'Params';
        }
      }
    });
  };
  $scope.search = _.debounce((function() {
    return $timeout(function() {
      $scope.filters.invoice_number = $scope.pageParams.invoice_number;
      if ($scope.tableParams.$params.page === 1) {
        return $scope.reload();
      } else {
        return $scope.tableParams.page(1);
      }
    });
  }), 450);
  $scope.reload = function() {
    return $scope.tableParams.reload();
  };
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 20
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend(stringifyParams({
        filters: $scope.filters
      }), $params.url());
      return GoCardless.all('api_logs').getList(params).then(function(data) {
        $params.total(data.meta.total);
        loadingAnimation.hide();
        return $defer.resolve(data);
      }, function() {
        loadingAnimation.hide();
        return flash.error = "There was an error processing the request.";
      });
    }
  });
}]);
